import store from "@/store";
import { get } from "lodash";
import { getFromCookie } from "@/utils/cryptoUtils";
import { convertBase64ToFile } from "@/utils/file-reader-helper";
import jwtdecode from "jwt-decode";

const proceedOnboarding = async () => {
  const idMeCode = this.getCodeFromUrl();
  const decodedPayload = getFromCookie("onboardingPayload");
  const base64String = localStorage.getItem("signatureImage");
  const file = convertBase64ToFile(base64String);
  const formData = new FormData();
  formData.append("image", file);
  if (decodedPayload && base64String) {
    decodedPayload.idMeCode = idMeCode || null;
    const response = await store.dispatch("publicAPIModule/clearLocalStore", decodedPayload);
    localStorage.removeItem("finalizeOnboarding");
    if (response && response.data) {
      // eslint-disable-next-line camelcase
      const { access_token } = response.data.sessionObject;
      const decodedToken = initializeLoginDetails(response.data.sessionObject);
      if (response.data.locationId) {
        const uploadResponse = await store.dispatch("filesModule/uploadImgFile", {
          formData,
        });
        if (uploadResponse) {
          const signatureFileLocation = get(uploadResponse, "data", "");
          await store.dispatch("accountsModule/addLocationSignature", {
            locationId: response.data.locationId,
            payload: {
              signatureFileLocation,
            },
          });
        } else {
          // throwSignatureError();
        }
      } else {
        // throwSignatureError();
      }
      // eslint-disable-next-line camelcase
      await store.dispatch("usersModule/initializeCurrentLoggedInInfo", { access_token: access_token, exp: decodedToken.exp, decodedToken });
      await store.dispatch("usersModule/navigateBasedOnRoles", { decodedToken });
      return;
    } else if (response.npiError) {
      setTimeout(async () => {
        await store.dispatch("publicAPIModule/logoutUser");
      }, 10000);
      return;
    }
    setTimeout(async () => {
      window.location.href = "/";
    }, 3500);
  }
};

const initializeLoginDetails = (_, loginDetails) => {
  // eslint-disable-next-line camelcase
  const { access_token } = loginDetails;
  const decodedToken = jwtdecode(access_token);
  const { id } = decodedToken.sim.details; // orgId or vendorId
  localStorage.setItem("access_token", access_token);
  localStorage.setItem("exp", decodedToken.exp);
  localStorage.removeItem("signatureImage");
  localStorage.setItem("orgId", id);
  return decodedToken;
};

export default {
  proceedOnboarding,
};
